import { createIndexedDBStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/indexed-db/index.tsx';
import type { AsyncStorage } from '@atlassian/jira-browser-storage-providers/src/types.tsx';
import { CACHE_NAME_PREFIX } from '../constants.tsx';

export const jiraCache: AsyncStorage = createIndexedDBStorageProvider(CACHE_NAME_PREFIX, {
	shouldAutoReconnect: true,
});
